import script from "./termsAcceptance.vue?vue&type=script&setup=true&lang=ts"
export * from "./termsAcceptance.vue?vue&type=script&setup=true&lang=ts"

import "./termsAcceptance.vue?vue&type=style&index=0&id=3c69c0cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c69c0cc"]])

export default __exports__